"use client";
import { useEffect } from "react";
import { DateTime } from "luxon";
import { COOKIE_KEYS, getCookie, setCookie } from "@portal/app/_common/lib/headers";
import {
  deserializeGoogleAdsAttribution,
  equalGoogleAdsAttribution,
  GOOGLE_ADS_WINDOW_DAYS,
  parseGoogleAdsAttribution,
  serializeGoogleAdsAttribution,
} from "@portal/app/_common/lib/googleAdsAttribution";
import { reportGoogleAdsDiagnostic } from "@portal/app/_common/lib/googleAdsTelemetry";

export function persistGoogleAdsAttributionFromUrl(): void {
  const incoming = parseGoogleAdsAttribution(window.location.search);
  if (!incoming) return;
  const raw = getCookie(COOKIE_KEYS.GOOGLE_ADS_ATTRIBUTION);
  const current = deserializeGoogleAdsAttribution(raw);
  if (raw && !current) reportGoogleAdsDiagnostic("invalid_cookie");
  if (equalGoogleAdsAttribution(current, incoming)) return;
  const serialized = serializeGoogleAdsAttribution({
    ...incoming,
    capturedAt: DateTime.utc().toISO()!,
  });
  if (!serialized) return;
  setCookie(COOKIE_KEYS.GOOGLE_ADS_ATTRIBUTION, serialized, { expires: GOOGLE_ADS_WINDOW_DAYS });
  const fields = Object.keys(incoming);
  if (fields.length > 1) reportGoogleAdsDiagnostic("multiple_ids", fields);
}

export function GoogleAdsAttributionScript() {
  useEffect(() => {
    persistGoogleAdsAttributionFromUrl();
  }, []);
  return null;
}
